import styled, { css } from 'styled-components/macro';

export const OtherFileWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.xs};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings.xxs};
    width: 150px;
    height: 180px;
    background-color: ${theme.colors.gray[400]};
    color: ${theme.colors.white};
    border-radius: ${theme.radiuses.xs};
  `}
`;
